// import React, { ChangeEvent } from "react";
import { Checkbox, FormControlLabel, FormHelperText, Switch, Typography } from "@mui/material";
import {
  useController,
  UseControllerReturn,
  useFormContext,
} from "react-hook-form";

export interface ISwitchProps {
  name: string
  label: string | any
  checked?: boolean
  hidden?: boolean
}

export const SwitchInput = (props: ISwitchProps) => {
  const { control, watch } = useFormContext();

  const controller: UseControllerReturn = useController({
    name: props.name,
    control
  });

  const label = watch(controller.field.name, controller.field.value) ? 'Já' : ''
  return (<>
    <Typography sx={{ backgroundColor: 'white', pl: 2, pt:1 }}>
      {props.label}
      </Typography>
      <Typography sx={{ backgroundColor: 'white', pl: 2 }}>
        
        {props.hidden 
        ?
        <Typography sx={{ml: 1}}>{controller.field.value ? 'Já' : 'Nei'}</Typography>
        :
        <FormControlLabel
          label={label}
          control={
            <Checkbox
              onChange={controller.field.onChange}
              onBlur={controller.field.onBlur}
              name={controller.field.name}
              value={controller.field.value}
              checked={controller.field.value}
              ref={controller.field.ref}
              defaultChecked={props.checked}
            />
          }
        />}

    </Typography>
    {!!controller.fieldState.error &&
        <FormHelperText sx={{backgroundColor: 'white', p:1, m:0, pl:2}} error={!!controller.fieldState.error}>
          {controller.fieldState.error?.message}
        </FormHelperText>
      }
  </>
  );
};
